function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Magic } from "devlink/Magic";
import { convertToMagicTag, getRunningPromptsText, wrapTextInMarkupLanguage } from "./utils";
function DevlinkMagicComponent({ tags = [], runningPrompts, mainHeadlineText, subHeadline, tagsTitle, ctaText }) {
    const magicTags = useMemo(()=>tags.reduce((acc, tag, index)=>_object_spread({}, acc, convertToMagicTag(tag, index)), {}), [
        tags
    ]);
    return /*#__PURE__*/ _jsx(Magic, _object_spread({
        runningPrompts: getRunningPromptsText(runningPrompts),
        mainHeadlineText: wrapTextInMarkupLanguage(mainHeadlineText),
        subHeadline: wrapTextInMarkupLanguage(subHeadline),
        tagsTitle: wrapTextInMarkupLanguage(tagsTitle),
        ctaText: wrapTextInMarkupLanguage(ctaText)
    }, magicTags));
}
export default DevlinkMagicComponent;
